export default "__VITE_ASSET__DTp7qgFi__"